import React, { useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import {
  Card,
  SearchableSelect,
  MachineFeProjection,
  Lottie,
} from "../../components";
import { AVAILABLE_PROJECTION_MODELS } from "../../utils/constants";
import WaitingAnimation from "../../assets/lotties/4272-data-dashboard.json";
import { setOpen } from "../../redux/reducers/modalScreen";
import { setProps } from "../../redux/reducers/globalDialog";
import { GlobalDialogProps } from "../../utils/types/components";
import { ProjectionsProps } from "../../utils/types/containers";

const SERVICES = _.values(AVAILABLE_PROJECTION_MODELS);

const Projections = ({
  onSetOpenModalScreen,
  setGlobalDialogProps,
}: ProjectionsProps): React.ReactElement => {
  const [serviceSelected, setServiceSelected] = useState(null);

  const getView = (opt: string): React.ReactElement => {
    switch (opt) {
      case AVAILABLE_PROJECTION_MODELS.OPT1:
        return (
          <MachineFeProjection
            setLoading={onSetOpenModalScreen}
            setDialog={setGlobalDialogProps}
          />
        );

      default:
        return (
          <div>
            <Lottie animationData={WaitingAnimation} width={600} height={500} />
          </div>
        );
    }
  };

  return (
    <Card type="principal" title="Proyecciones por Modelo Predictivo">
      <SearchableSelect
        label="Tipo de Modelo Predictivo"
        options={SERVICES}
        getOptionLabel={(opt: string) => opt}
        onChange={(y) => setServiceSelected(y)}
        style={{ marginTop: 30, marginBottom: 30 }}
      />

      {getView(serviceSelected)}
    </Card>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: (value: any) => unknown) => ({
  onSetOpenModalScreen: (open) => dispatch(setOpen(open)),
  setGlobalDialogProps: (obj: GlobalDialogProps) => dispatch(setProps(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Projections);
